export var createTestOfflineAudioContextCurrentTimeSupport = function createTestOfflineAudioContextCurrentTimeSupport(createNativeGainNode, nativeOfflineAudioContextConstructor) {
  return function () {
    if (nativeOfflineAudioContextConstructor === null) {
      return Promise.resolve(false);
    }

    var nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100); // Bug #48: Safari does not render an OfflineAudioContext without any connected node.

    var gainNode = createNativeGainNode(nativeOfflineAudioContext, {
      channelCount: 1,
      channelCountMode: 'explicit',
      channelInterpretation: 'discrete',
      gain: 0
    }); // Bug #21: Safari does not support promises yet.

    return new Promise(function (resolve) {
      nativeOfflineAudioContext.oncomplete = function () {
        gainNode.disconnect();
        resolve(nativeOfflineAudioContext.currentTime !== 0);
      };

      nativeOfflineAudioContext.startRendering();
    });
  };
};